module.exports = __webpack_public_path__ + "img/prvedomy2_map.92f89f04.jpg";